module.exports = __webpack_public_path__ + "img/DSC_2684-xl.5a39b2ff.png";